// POS modal zIndex is 1501
export const previewModalZIndex = 1500;
export const ticketsAndSeatsZIndex = previewModalZIndex + 1;
export const draggingWrapperZIndex = previewModalZIndex + 2;
